import request from '@/utils/request.js';

//新增会员福利
export function AddActivityCoupon(values) {
  return request('/activityCoupon/addActivityCoupon', {
    method: 'POST',
    data: values,
  });
}

//查询会员福利详情
export function getQueryActivityDetail(values) {
  return request('/activityCoupon/queryActivityDetail', {
    method: 'POST',
    data: values,
  });
}

//更新会员福利详情
export function updateActivityCoupon(values) {
  return request('/activityCoupon/updateActivityCoupon', {
    method: 'POST',
    data: values,
  });
}
//保存二维码
export function saveQrCodeGroup(values) {
  return request('/activityCoupon/saveQrCodeGroup', {
    method: 'POST',
    data: values,
  });
}
//下载二维码
export function downloadQRCode(values) {
  return request('/activityCoupon/downloadQRCode', {
    method: 'POST',
    data: values,
  });
}
//查询pagepath
export function queryQrCodePagePath(values) {
  return request('/wechat/mini/queryQrCodePagePath', {
    method: 'POST',
    data: values,
  });
}
//查询二维码
export function qrcodeGroupInfo(values) {
  return request('/activityCoupon/qrcodeGroupInfo', {
    method: 'POST',
    data: values,
  });
}

